import React from "react";
import Layout from "./layout/Layout";
import BrandThree from "../elements/brand/BrandThree";
import SEO from "../common/SEO";
import SplitOne from "../elements/split/SplitOne";
import Separator from "../elements/separator/Separator";
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import ServiceOne from "../elements/service/ServiceOne";
import PricingFive from "../elements/pricing/PricingFive";
import CalltoActionThree from "../elements/calltoaction/CalltoActionThree";
import Split from "../elements/split/Split";
import SlipTwo from "../elements/split/SlipTwo";
import TabThree from "../elements/tab/TabThree";
import TabTwo from "../elements/tab/TabTwo";
import ServiceThree from "../elements/service/ServiceThree";
import ServiceTwo from "../elements/service/ServiceTwo";

const  CsmsDevelopment = () =>{
    return(
        <>
            <SEO title="IOS App Development"/>
            <Layout>
                {/* Start Service Area  */}
                <div className="service-area rn-section-gapTop">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-9">
                                <div className="content">
                                    <h3 className="title">IOS App Development</h3>
                                    <p className="mb--10">As a leading app development company, we specialize in delivering
                                        innovative and customized iPhone/iOS applications using advanced technologies to enhance
                                        your business. Partner with us for next-generation solutions</p>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <img src="../images/ios/ios5.jpg" alt="split Images"/>
                            </div>
                        </div>
                    </div>
                </div>
                <Separator/>
                {/* Start Service Area  */}
                <Separator/>
                <Separator/>
                {/* Start Service Area  */}
                <div className="rn-service-area rn-section-gap ">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <SectionTitle
                                    textAlign = "text-center"
                                    radiusRounded = ""
                                    subtitle = ""
                                    title = "Why Choose Us for Android App Design & Development"
                                    description = "Our expert Android developers create high-quality and functional
                                     Android applications using the latest tools and technologies. Our internal team
                                     of developers writes the code and performs rigorous testing to eliminate any bugs
                                     or errors in the app. Through continuous integration, we conduct multiple rounds of
                                     testing to ensure the app's reliability and stability. Before release, we carefully
                                     review the code and make any necessary updates.  We continuously monitor the app
                                     post-release to ensure its seamless performance and eliminate any future bugs."/>
                            </div>
                        </div>
                        <ServiceTwo
                            serviceStyle = "service__style--1 bg-color-blackest radius mt--25 rbt-border"
                            textAlign = "text-left"
                        />
                    </div>
                </div>
                {/* End Service Area  */}
                <CalltoActionThree/>
            </Layout>
        </>
    )
}

export  default  CsmsDevelopment;